import React from 'react';
// tools
import { Route, Routes } from "react-router-dom";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
// pages
import About from "./pages/public/about/About";
import PageNotFound from "./pages/pageNotFound/PageNotFound";
import PublicProposedPage from "./pages/public/rules/components/proposed/PublicProposed";
import Dashboard from "./pages/state/dashboard/Dashboard";
import Filings from "./pages/state/filings/Filings";
import StatePageNotFound from "./pages/pageNotFound/StatePageNotFound";
import WorkQueue from "./pages/state/workqueue/WorkQueue";
import CodeManagement from "./pages/state/codeManagement/CodeManagement";
import ChapterHistoryManagement from './pages/state/chapterHistoryManagement/ChapterHistoryManagement';
import CodeDrafting from "./pages/state/codeDrafting/CodeDrafting";
import RulesPage from "./pages/public/rules/Rules";
import SubscriptionProfilePage from "./pages/public/subscriptionProfile/SubscriptionProfile";
import AdminManagement from "./pages/state/adminManagement/AdminManagement";
import StateErrorEncountered from './pages/errorEncounteredPage/ErrorEncountered';
// CSS
import "@progress/kendo-theme-bootstrap/dist/all.css";
import "./App.css";
// redux store
import Authorized from './components/stateful/authorized/Authorized';
import { Roles } from './utilities/enums/Roles';
import HistoricalDrafts from './pages/state/historicalDrafts/HistoricalDrafts';
import HistoricalFilings from './pages/state/historicalFilings/HistoricalFilings';

function App() {

    return (
        <React.Fragment>
            <Routes>

                <Route path='/state'>
                    <>
                        <Route
                            path='dashboard'
                            element={
                                <>
                                    <AuthenticatedTemplate>
                                        <Dashboard />
                                    </AuthenticatedTemplate>
                                    <UnauthenticatedTemplate>
                                        <RulesPage />
                                    </UnauthenticatedTemplate>
                                </>
                            }
                            errorElement={<StateErrorEncountered />}
                        />
                        <Route
                            path='work-queue'
                            element={
                                <>
                                    <AuthenticatedTemplate>
                                        <WorkQueue />
                                    </AuthenticatedTemplate>
                                    <UnauthenticatedTemplate>
                                        <RulesPage />
                                    </UnauthenticatedTemplate>
                                </>
                            }
                        />
                        <Route
                            path='code-management'
                            element={
                                <>
                                    <AuthenticatedTemplate>
                                        <CodeManagement />
                                    </AuthenticatedTemplate>
                                    <UnauthenticatedTemplate>
                                        <RulesPage />
                                    </UnauthenticatedTemplate>
                                </>
                            }
                            errorElement={<StateErrorEncountered />}
                        />
                        <Route
                            path='chapter-history-management'
                            element={
                                <>
                                    <AuthenticatedTemplate>
                                        <ChapterHistoryManagement />
                                    </AuthenticatedTemplate>
                                    <UnauthenticatedTemplate>
                                        <RulesPage />
                                    </UnauthenticatedTemplate>
                                </>
                            }
                            errorElement={<StateErrorEncountered />}
                        />
                        <Route
                            path='draft'
                            element={
                                <>
                                    <AuthenticatedTemplate>
                                        <CodeDrafting />
                                    </AuthenticatedTemplate>
                                    <UnauthenticatedTemplate>
                                        <RulesPage />
                                    </UnauthenticatedTemplate>
                                </>
                            }
                            errorElement={<StateErrorEncountered />}
                        />
                        <Route
                            path='filings'
                            element={
                                <>
                                    <AuthenticatedTemplate>
                                        <Filings />
                                    </AuthenticatedTemplate>
                                    <UnauthenticatedTemplate>
                                        <RulesPage />
                                    </UnauthenticatedTemplate>
                                </>
                            }
                            errorElement={<StateErrorEncountered />}
                        >
                            <Route
                                path=':id'
                                element={
                                    <>
                                        <AuthenticatedTemplate>
                                            <Filings />
                                        </AuthenticatedTemplate>
                                        <UnauthenticatedTemplate>
                                            <RulesPage />
                                        </UnauthenticatedTemplate>
                                    </>
                                } errorElement={<StateErrorEncountered />}
                            />
                        </Route>
                        <Route path={'*'} element={<StatePageNotFound />} />
                        <Route
                            path={'admin-management'}
                            element={
                                <>
                                    <AuthenticatedTemplate>
                                        <Authorized roles={[Roles.Admin]} type="page">
                                            <AdminManagement />
                                        </Authorized>
                                    </AuthenticatedTemplate>
                                    <UnauthenticatedTemplate>
                                        <RulesPage />
                                    </UnauthenticatedTemplate>
                                </>
                            }
                            errorElement={<StateErrorEncountered />}
                        />
                        <Route
                            path={'historical-drafts'}
                            element={
                                <>
                                    <AuthenticatedTemplate>
                                        <HistoricalDrafts />
                                    </AuthenticatedTemplate>
                                    <UnauthenticatedTemplate>
                                        <RulesPage />
                                    </UnauthenticatedTemplate>
                                </>
                            }
                        />
                        <Route
                            path={'historical-filings'}
                            element={
                                <>
                                    <AuthenticatedTemplate>
                                        <HistoricalFilings />
                                    </AuthenticatedTemplate>
                                    <UnauthenticatedTemplate>
                                        <RulesPage />
                                    </UnauthenticatedTemplate>
                                </>
                            }
                        />
                    </>

                </Route>



                <Route path="/rules" element={<RulesPage rules={true} />} />
                <Route path="/about" element={<About />} />
                <Route path="/proposed" element={<PublicProposedPage />} />
                <Route path="/subscriptionProfile" element={<SubscriptionProfilePage />}/>
                <Route path="*" element={<PageNotFound />} />
                <Route path="/password-reset/:passwordToken" element={<RulesPage resetPassword={true}/>} />
                <Route path="/activate-account/:activationToken" element={<RulesPage activateAccount={true}/>} />
                <Route path="/browse-rules" element={<RulesPage selected={1}/>} />
                <Route path="/docket" element={<RulesPage selected={2}/>} />
                <Route path="/" element={<RulesPage />} />
            </Routes>
        </React.Fragment>
    );
}

export default App;